module.exports = __webpack_public_path__ + "static/scale-model-of-las-olas-beach-in-fort-lauderdale-florida-7ffd4ab3d0b2508e337f09f7d616019d.png";